import React, { FC } from 'react';
import FollowTopic from './follow-topic';
import { useAtomValue } from 'jotai';
import { $CurrentAvailableUserOrNull } from '@user/shared/atoms/current-user';
import { NotFound } from '~/components/not-found';

export const UserFollowTopicBody: FC = () => {
  const user = useAtomValue($CurrentAvailableUserOrNull);

  if (!user) {
    return <NotFound />;
  }

  return <FollowTopic />;
};
